import * as Sentry from '@sentry/react';

export default function loadSentry() {
    if (!['development', 'qa', 'feature', 'staging'].includes(process.env.REACT_APP_ENV)) {
        Sentry.init({
            dsn: 'https://0ecfea4de8104eb3ab39d99362bf4697@o144424.ingest.sentry.io/6079044',
            environment: process.env.REACT_APP_ENV,
        });
    }
}
